import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { toast } from "react-toastify";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  totalPages: number;
  currentPage: number;
  onChangeCustom: React.ChangeEventHandler<HTMLInputElement>;
}

const PageSelector: React.FC<IParams> = ({
  totalPages,
  currentPage,
  onChangeCustom,
}) => {
  const [t] = useTranslation(["browse_page"], translationHookOptions);
  const rootStore = useContext(RootStoreContext)
  const {
    setGalleryPage,
  } = rootStore.commonStore;

  const [tempPage, setTempPage] = useState(currentPage);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


useEffect (() => { 
  setTempPage(currentPage);
 }, 
 
[currentPage]);


// const handleClickOutside = (event: TouchEvent) => {
// // toast.info("handleClickOutside");
//   if (inputRef.current && !inputRef.current.contains(event.target as Node)) {
//     // Recupera il valore dell'input
//     const inputValue = inputRef.current.value;
//     // Esegui qualsiasi logica aggiuntiva qui
//     handleBlur(inputValue);
//   }
// };

const handleClickOutside = (event: MouseEvent | TouchEvent) => {
  // toast.info("handleClickOutside");
  
  // Determina il tipo di evento
  let targetElement: Node | null = null;
  if (event instanceof MouseEvent) {
    targetElement = event.target as Node;
  } else if (event instanceof TouchEvent) {
    targetElement = event.touches[0].target as Node;
  }

  // Controlla se il click/touch è al di fuori dell'elemento di input
  if (inputRef.current && !inputRef.current.contains(targetElement)) {
    // Recupera il valore dell'input
    const inputValue = inputRef.current.value;
    // Esegui qualsiasi logica aggiuntiva qui
    handleBlur(inputValue);
  }
};

const handleBlur = (value:string) => {
  setGalleryPage(Number(value) - 1, totalPages);
};

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTempPage(Number(event.target.value));
  };


  return (
    <FormGroup
      row
      className="mb-0 ml-auto  justify-content-center toolbarHeight"
    >
      <Label
        for="pagina"
        className="mb-0 align-self-center toolbarText pagina toolbarPageLabel-long"
      >
        {t("toolbar_page_selector_longtext")}
      </Label>
      <Label
        for="pagina"
        className="mb-0 align-self-center toolbarText pagina toolbarPageLabel-short"
      >
        Pag.
      </Label>
      <Input
      innerRef={inputRef} 
        className="form-control-sm toolbarPageInput align-self-center mx-1 px-0"
        type="number"
        name="pagina"
        id="pagina"
        //  onFocus={(event) => event.target.select()}
         value={tempPage}
        //  onChange={onChangeCustom}
          onChange={(event)=>handleChange(event)}
      />
      <Label
        for="pagina"
        className="mb-0 align-self-center toolbarText toolbarPageLabel-long"
      >
        {t("toolbar_page_selector_longtext_separator")} {totalPages}
      </Label>
      <Label
        for="pagina"
        className="mb-0 align-self-center toolbarText toolbarPageLabel-short"
      >
        /{totalPages}
      </Label>
    </FormGroup>
  );
};

export default PageSelector;
